import {
  ImportSourceDto,
  ManfrediteImportSource
} from 'interfaces/dto/import-source.dto';
import { Manfredite } from 'interfaces/manfredite.interface';
import { config } from 'utils/config';
import * as fetch from 'utils/fetch';

const BASE_URL_PUBLIC = `${config.apiUrl}`;
const BASE_URL = `${process.env.basePath}/api/manfredite/profile`;

const StackOverflowService = {
  importManfrediteFromDevStories: async (
    dsURL: string
  ): Promise<Manfredite> => {
    const data = await fetch.post<
      ImportSourceDto,
      {
        data: Manfredite;
        message: string;
      }
    >(`${BASE_URL}/import`, {
      source: ManfrediteImportSource.DEV_STORY,
      username: dsURL
    });

    return data.data;
  },

  importManfrediteFromDevStoriesPDF: async (
    dsPDF: File
  ): Promise<Manfredite> => {
    const params = new FormData();

    params.append('attached', dsPDF ?? '');

    const data = await fetch.post<
      FormData,
      {
        data: Manfredite;
      }
    >(`${BASE_URL}/import/pdf`, params, {
      headers: {}
    });

    return data.data;
  },

  downloadDevStoryAsMAC: (url: string): Promise<any> => {
    return fetch.post<
      {
        dsUrl: string;
      },
      void
    >(`${BASE_URL_PUBLIC}/public/imports/so`, {
      dsUrl: url
    });
  },

  downloadDevStoryPDFAsMAC: (file: File): Promise<any> => {
    const params = new FormData();

    params.append('attached', file ?? '');

    return fetch.post<FormData, any>(
      `${BASE_URL_PUBLIC}/public/imports/so/pdf`,
      params,
      {
        headers: {}
      }
    );
  }
};

export default StackOverflowService;
